"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextElementNova = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _dompurify = _interopRequireDefault(require("dompurify"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
/**
 * Primary UI component for Text
 * Text Design System
 * https://www.figma.com/design/2N4gMTqYSm9oGSouVxbvCW/Nutrafol---Website-2024?node-id=1-3111&m=dev&ready-for-dev=1
 */
var validElements = ["h1", "h2", "h3", "h4", "h5", "h6", "p", "span", "button"];
var invalidElements = validElements.filter(function (el) {
  return !["span", "button"].includes(el);
});
var showWarning = (typeof window === "undefined" ? "undefined" : _typeof(window)) === "object" && window.location.hostname.includes("localhost");
var clsPrefix = "textelement nova ";
var colorPrefix = " text-nova-base-black ";
var TextElementNova = function TextElementNova(_ref) {
  var _ref$text = _ref.text,
    text = _ref$text === void 0 ? "" : _ref$text,
    element = _ref.element,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
    _ref$onKeyPress = _ref.onKeyPress,
    onKeyPress = _ref$onKeyPress === void 0 ? function () {} : _ref$onKeyPress,
    _ref$classes = _ref.classes,
    classes = _ref$classes === void 0 ? [] : _ref$classes,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    styles = _ref.styles,
    _ref$sanitize = _ref.sanitize,
    sanitize = _ref$sanitize === void 0 ? false : _ref$sanitize,
    children = _ref.children;
  /*
   *  classes prop handler
   *  we set default as mobile first class
   *  then detecting breakpoints
   */
  var css = "";
  var classNameDefault = "";
  if (classes["default"]) {
    var _require = require("../styles/nova-fonts.js"),
      novaFonts = _require.novaFonts;
    classNameDefault = classes === null || classes === void 0 ? void 0 : classes["default"];
    var classesKeys = Object.keys(classes).sort(function (a, b) {
      return a - b;
    }).filter(function (el) {
      return el !== "default";
    });
    var buildStyle = function buildStyle(obj) {
      //console.log(obj)
      var res = "";
      for (var k in obj) {
        res += "\t".concat(k, ": ").concat(obj[k], " !important;\n");
      }
      return res;
    };
    var bp0 = classesKeys[0];
    var bp1 = classesKeys[1];
    var temp;

    //add first media
    if (bp0) {
      temp = novaFonts[classes[bp0]];
      if (temp) {
        css += "@media (min-width: ".concat(bp0, "px) {\n").concat(buildStyle(temp[bp0 < 1024 ? 1 : 2]), "}\n");
      } else {
        console.warn("invalid class passed ".concat(classes[bp0]));
      }
    }

    //add second media
    if (bp1) {
      temp = novaFonts[classes[bp1]];
      if (temp) {
        css += "@media (min-width: ".concat(bp1, "px) {\n").concat(buildStyle(temp[bp1 < 1024 ? 1 : 2]), "}\n");
      } else {
        console.warn("invalid class passed ".concat(classes[bp1]));
      }
    }
  }
  if (showWarning && css) {
    //console.info(css)
  }
  var Element = validElements.includes(element) ? element : "p";
  // p can contain only Phrasing content  - span, button etc https://nutrafol.atlassian.net/browse/NT2-11229
  if (Element === "p") {
    invalidElements.forEach(function (el) {
      if (text && typeof text.includes === "function" && text.includes("<".concat(el))) {
        //replace all non Phrasing content with a SPAN
        showWarning && console.warn("TextElement: <".concat(el.toUpperCase(), "> in <P> replaced with <SPAN>"), text);
        var reg1 = new RegExp("(<".concat(el, ")"), "igm");
        var reg2 = new RegExp("(</".concat(el, ")"), "igm");
        text = text.replace(reg1, "<span").replace(reg2, "</span");
      }
    });
  }
  // styles added based on classes
  var StyledTextElement = /*#__PURE__*/(0, _base["default"])(Element, process.env.NODE_ENV === "production" ? {
    target: "e12qod00"
  } : {
    target: "e12qod00",
    label: "StyledTextElement"
  })(css, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
  var fullClassName = "".concat(clsPrefix, " ").concat(className, " ").concat(classNameDefault);
  if (!fullClassName.includes("text-nova-")) {
    fullClassName += colorPrefix;
  }
  if ( /*#__PURE__*/_react["default"].isValidElement(text)) {
    return /*#__PURE__*/_react["default"].createElement(StyledTextElement, {
      className: fullClassName,
      style: styles,
      onClick: onClick,
      onKeyPress: onKeyPress
    }, sanitize ? _dompurify["default"].sanitize(text, {
      ALLOWED_TAGS: []
    }) : text);
  }
  if (children) {
    return /*#__PURE__*/_react["default"].createElement(StyledTextElement, {
      className: fullClassName,
      style: styles,
      onClick: onClick,
      onKeyPress: onKeyPress
    }, children);
  }
  return /*#__PURE__*/_react["default"].createElement(StyledTextElement, {
    className: fullClassName,
    style: styles,
    onClick: onClick,
    onKeyPress: onKeyPress,
    dangerouslySetInnerHTML: {
      __html: sanitize ? _dompurify["default"].sanitize(text, {
        ALLOWED_TAGS: []
      }) : text
    }
  });
};
exports.TextElementNova = TextElementNova;
TextElementNova.propTypes = {
  /**
   * text or html string or node
   */
  text: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object, _propTypes["default"].number]),
  /**
   * what element to render
   */
  element: _propTypes["default"].string,
  /**
   * Optional string of classes
   */
  className: _propTypes["default"].string,
  /**
   * Optional object of styles
   */
  styles: _propTypes["default"].object,
  /**
   * Optional onClick handler
   */
  onClick: _propTypes["default"].func,
  /**
   * Optional onKeyPress handler
   */
  onKeyPress: _propTypes["default"].func,
  /**
   * Optional classes array
   */
  classes: _propTypes["default"].object
};
TextElementNova.defaultProps = {
  element: "p"
};